import { ShieldCheck, ShieldAlert } from "lucide-react";

/* Proctoring verdict shown on every report: Verified true/false + why.
   `p` is result.proctor from the backend (may be absent on old attempts). */
export default function ProctorVerdict({ p, integrity, dark = false }) {
  if (!p) {
    if (!integrity) return null;
    const ok = integrity === "clean";
    return <p className={ok ? "text-emerald-400" : integrity === "minor" ? "text-amber-300" : "text-red-400"}>Integrity: {integrity}</p>;
  }
  const ok = p.verified;
  const tone = ok ? (dark ? "text-emerald-400" : "text-emerald-700") : (dark ? "text-red-400" : "text-red-700");
  return (
    <div className="text-sm space-y-0.5" data-testid="proctor-verdict">
      <p className={`inline-flex items-center gap-1.5 font-medium ${tone}`}>
        {ok ? <ShieldCheck size={15} /> : <ShieldAlert size={15} />}
        Verified: {ok ? "true" : "false"} · {p.face_visible ? "face visible" : "face not visible"}
      </p>
      {p.notes?.length > 0 && <p className={dark ? "text-stone-300" : "text-stone-600"}>{p.notes.join(" · ")}</p>}
      {!ok && <p className={dark ? "text-stone-400" : "text-stone-500"}>This attempt is marked unverified and counts for less in your Wishire Score. Keep your face in the camera next time.</p>}
    </div>
  );
}
